module.exports = __webpack_public_path__ + "static/media/13.726ea0c4.png";